import React from 'react';
import OrderContainer from '@src/containers/Order';
import PermissionGate from '@src/components/PermissionGate';
import { PERMISSIONS } from '@src/constants';

const Order = () => (
  <PermissionGate
    requiredPermissions={[
      PERMISSIONS.VIEW_ORDER,
      PERMISSIONS.EDIT_ORDER,
      PERMISSIONS.CREATE_ORDER,
      PERMISSIONS.DELETE_ORDER,
    ]}
  >
    <OrderContainer />
  </PermissionGate>
);

export default Order;
